import AdView from "../../components/ad/Ad/AdView"

export const AdPage = () => {

    return (
        <AdView></AdView>
    )
}